import CalendarIcon from '@assets/icons/calendar-icon.svg';
import JoinIcon from '@assets/icons/Icon-material-video-call.svg';
import { ReactComponent as BinIcon } from '@assets/icons/V4/trash-icon.svg';
import RescheduleModal from '@components/V4/RescheduleModal';
import { searchMyMeetings } from '@shared/apis/meetings.apis';
import { Meeting, MeetingStatus } from '@shared/common';
import { useUpdateMeeting } from '@actions';
import button from '@styles/components/reusables/buttons.module.scss';
import { useAnalytics } from 'apps/agora/src/contexts/AnalyticsContext';
import { ANALYTICS_EVENT_NAMES } from 'apps/agora/src/utils/constants';
import React, { useState } from 'react';
import { useQueryClient } from 'react-query';
import { Link } from 'react-router-dom';
import { COLORS } from '../../../../../v3/global';
import MeetingListItemButton from './MeetingListItemButton';
import useToast from 'apps/agora/src/hooks/useToast';

interface JoinButtonProps {
  meeting: Meeting;
  hideJoinAndRescheduleBtn?: boolean;
  afterSave?: () => void;
}

const JoinButtonMentor: React.FC<JoinButtonProps> = ({
  meeting,
  hideJoinAndRescheduleBtn,
  afterSave,
}) => {
  const [isRescheduleModalOpen, setIsRescheduleModalOpen] = useState(false);

  const queryClient = useQueryClient();

  const { trackEvent } = useAnalytics();
  const toast = useToast();

  const { mutate: updateMeeting } = useUpdateMeeting(meeting._id, {
    onSuccess: () => {
      trackEvent(ANALYTICS_EVENT_NAMES.MEETING_CANCEL);
      queryClient.refetchQueries(searchMyMeetings.endpoint);
      toast.success('Meeting cancelled successfully.');
    },
  });

  const rescheduleClickHandler = () => {
    trackEvent(ANALYTICS_EVENT_NAMES.MEETING_RESCHEDULE_BUTTON_CLICK);
    setIsRescheduleModalOpen(true);
  };

  const cancelButtonClickHandler = () => {
    trackEvent(ANALYTICS_EVENT_NAMES.MEETING_CANCEL_BUTTON_CLICK);
    updateMeeting({ status: MeetingStatus.CANCELLED });
  };

  const rescheduleHandler = () => {
    afterSave?.();
    setIsRescheduleModalOpen(false);
  };

  return (
    <div className={button.joinButtonMentorContainer}>
      {!hideJoinAndRescheduleBtn && (
        <>
          <span
            style={{
              color: COLORS.TEXT_PRIMARY,
            }}
            className={`${button.actionButton} gradient ${button.joinButtonMentorJoinContainer}`}
          >
            <MeetingListItemButton>
              <Link
                to={`/video-meeting/${meeting._id}`}
                className="flex items-center w-full h-full text-inherit py-2 px-4"
              >
                <img src={JoinIcon} className={button.joinButtonMentorIcon} />
                <span className="text-white">Join Meeting</span>
              </Link>
            </MeetingListItemButton>
          </span>

          <MeetingListItemButton>
            <div
              onClick={rescheduleClickHandler}
              className="flex items-center w-full h-full text-white py-2 px-4"
            >
              <img src={CalendarIcon} alt="Join meeting" className={button.joinButtonMentorIcon} />
              <div className="nowrap">Reschedule Meeting</div>
            </div>
          </MeetingListItemButton>
        </>
      )}
      <MeetingListItemButton>
        <div
          onClick={cancelButtonClickHandler}
          className="flex items-center w-full h-full text-white py-2 px-4"
        >
          <BinIcon className="w-3.5 text-customRed mr-3" />
          <span className="nowrap">Cancel Meeting</span>
        </div>
      </MeetingListItemButton>
      {isRescheduleModalOpen && (
        <RescheduleModal
          isOpen
          onClose={() => setIsRescheduleModalOpen(false)}
          meetingId={meeting._id}
          onReschedule={rescheduleHandler}
        />
      )}
    </div>
  );
};

export default JoinButtonMentor;
